import { useQuery } from "@tanstack/react-query";

import { getPopup } from "services";

import { GET_ALL_ADMIN_POPUPS_BY_ID } from "consts";

import { Popup } from "models";

export const useGetAllPopupsForATypeAdmin = (id: string) =>
  useQuery<Popup[]>({
    queryKey: [GET_ALL_ADMIN_POPUPS_BY_ID, id],
    queryFn: ({ signal }) => getPopup({ id, signal }),
  });
